const theme = {
  colors: {
    text: '#454f5b',
    background: 'rgb(56, 64, 74)',
    primary: '#663399',
    secondary: '#000',
    success: '#00D100',
    failure: '#FF2E2E',
  },
  fonts: {
    body: '-apple-system, Roboto, sans-serif, serif',
    heading: '-apple-system, Roboto, sans-serif, serif',
    monospace: 'Menlo, monospace',
  },
  select: {
    background: '#fff',
  },
  styles: {
    a: {
      color: 'primary',
      ':hover, :focus': {
        color: 'secondary',
      },
    },
  },
  Tabs: {
    variants: {
      unstyled: {
        paddingY: '4',
        marging: '0',
        tab: {
          _selected: {
            color: 'white',
            boxShadow: 'none',
          },
        },
      },
    },
  },
}

export default theme
